const wowApp = require('angular').module('wowApp.shop');

wowApp.component('wowCheckoutConfirmation', require('./checkoutconfirmation.component').checkoutConfirmationControllerComponentDefinition);
wowApp.component('wowOrderConfirmationExportOptions', require('./order-confirmation-export-options.component').orderConfirmationExportOptionsControllerComponentDefinition);
wowApp.component('wowOrderConfirmationPanel', require('./order-confirmation-panel.component').orderConfirmationPanelControllerComponentDefinition);
wowApp.service('OrderConfirmationEmailService', ['Restangular', require('./order-confirmation-export-email.service')]);
wowApp.component('wowOrderConfirmationPrint', require('./order-confirmation-print.component').orderConfirmationPrintControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/order/confirmation/index.js